import React, { useState } from "react";
import { useHistory } from "react-router";
import { history } from "../../redux/helpers";
import { PImage } from "../images/images";

const ROLE_LABELS = {
  company: "Company Owner",
  company_employee: "Employee",
  company_courier: "Courier",
};

const MULTI_ROLES = ["company", "company_employee", "company_courier"];

export default function SwitchAccount() {
  let user = JSON.parse(localStorage.getItem("user"));

  const historyy = useHistory();
  const [pendingTeam, setPendingTeam] = useState(null); // { id, roles, display_name }

  const routeByRole = (role) => {
    localStorage.setItem("activeRole", role);
    historyy.push(role === "company_courier" ? "/courier/dashboard" : "/");
  };

  const setTeam = (id) => {
    localStorage.setItem("teamId", JSON.stringify(id));

    if (id === "administrator") {
      history("/auth/userRedirect");
      return;
    }

    const roles = user?.data?.team_roles?.[id]?.roles ?? [];
    const selectableRoles = roles.filter((r) => MULTI_ROLES.includes(r));

    if (selectableRoles.length > 1) {
      setPendingTeam({
        id,
        roles: selectableRoles,
        display_name: user.data.team_roles[id].display_name,
      });
      return;
    }

    // single role — route directly
    const role = selectableRoles[0] ?? "company";
    routeByRole(role);
  };

  // Role picker view
  if (pendingTeam) {
    return (
      <div>
        <h2 className=" h-align">Choose a role</h2>
        <div className="card mx-auto " style={{ width: "25rem" }}>
          <ul className="list-group list-group-flush">
            {pendingTeam.roles.map((role) => (
              <li
                className="list-group-item cursor-pointer"
                key={role}
                onClick={() => routeByRole(role)}
              >
                <div className="d-flex flex-row img-txt">
                  <img
                    className="p-img"
                    src={user?.data?.picture || PImage}
                    alt="user"
                  />
                  <div className=" d-flex flex-column ml-2">
                    <p className="text-capitalize m-0">{pendingTeam.display_name}</p>
                    <p className="text-capitalize">{ROLE_LABELS[role] ?? role}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2 className=" h-align">Choose an account</h2>
      <div className="card mx-auto " style={{ width: "25rem" }}>
        <ul className="list-group list-group-flush">
          {Object.keys(user.data.team_roles) &&
            Object.keys(user.data.team_roles).map((role) => (
              <li
                className="list-group-item cursor-pointer"
                key={role}
                onClick={() => setTeam(role)}
              >
                <div className="d-flex flex-row img-txt">
                  <img
                    className="p-img"
                    src={user?.data?.picture || PImage}
                    alt="user"
                  />
                  <div className=" d-flex flex-column ml-2">
                    <p className="text-capitalize m-0">
                      {user.data.team_roles[role].display_name}{" "}
                    </p>
                    <p className="text-capitalize">
                      {role === "administrator"
                        ? "Administrative Account"
                        : "Company Account"}
                    </p>
                  </div>
                </div>
              </li>
            ))}

          <div className="card mx-auto " style={{ width: "25rem" }}>
            <li
              className="list-group-item cursor-pointer"
              onClick={() => historyy.push("/userDashboard")}
            >
              <div className="d-flex flex-row img-txt">
                <img
                  className="p-img"
                  src={user?.data?.picture || PImage}
                  alt=""
                />
                <div className=" d-flex flex-column ml-2">
                  <p className="text-capitalize m-0"> {user.data.name} </p>
                  <p className="text-capitalize">{"Personal Account"}</p>
                </div>
              </div>
            </li>
          </div>
        </ul>
      </div>
    </div>
  );
}
